import script from "./TreatmentsTrialsPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./TreatmentsTrialsPagination.vue?vue&type=script&setup=true&lang=js"

import "./TreatmentsTrialsPagination.vue?vue&type=style&index=0&id=9b88c5e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b88c5e6"]])

export default __exports__